import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputBase,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputStylefield from "../../assets/InputStylefield";
import Select from "react-select";
import JoditEditor from "jodit-react";
import { useRef } from "react";
import UserLayout from "../../assets/UserLayout";
import Layout from "../../assets/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";

export default function AddServices() {
  // const [service, setService] = useState("");
  const editor = useRef(null);

  const colourOptions = [
    { value: "Commision pay", label: "Commision pay" },
    { value: "Overtime pay", label: "Overtime pay" },
    { value: "Joining bonus", label: "Joining bonus" },
  ];

  const colourOptions1 = [
    { value: "Computer assistant", label: "Computer assistant" },
    { value: "Flexible schedule", label: "Flexible schedule" },
    { value: "Food provided", label: "Food provided" },
  ];

  const [coach, setCoach] = useState('')
  const [serviceName, setServiceName] = useState('')
  const [trainingName, setTrainingName] = useState('')
  const [medium, setMedium] = useState("")
  const [language, setLanguage] = useState("")
  const [numberOfSessions, setNumberOfSessions] = useState('')
  const [durationPerSession, setDurationPerSession] = useState('')
  const [totalDuration, setTotalDuration] = useState('')
  const [descriptionByCoach, setDescriptionByCoach] = useState('')
  const [keyFeatures, setKeyFeatures] = useState('')
  const [currency, setCurrency] = useState('')
  const [suggestedPrice, setSuggestedPrice] = useState('')
  const [enterPrice, setEnterPrice] = useState('')
  const [earnedPrice, setEarnedPrice] = useState('')
  const [serviceStartedOn, setServiceStartedOn] = useState('')
  const [serviceLastEditedOn, setServiceLastEditedOn] = useState('')
  const [description, setDescription] = useState('')
  const { user } = useSelector((state) => ({ ...state }));


  const navigate = useNavigate();

  const handleLanguageChange = (selectedOption) => {
    setLanguage(selectedOption);
  };

  const handleMediumChange = (selectedOption) => {
    setMedium(selectedOption);
  };

  const handlePreview = () => {

     // Save data in local storage
     let data = {
      coach: user._id,
      serviceName,
      medium,
      language,
      numberOfSessions,
      durationPerSession,
      totalDuration,
      descriptionByCoach,
      keyFeatures,
      currency,
      suggestedPrice,
      enterPrice,
      earnedPrice,
      serviceStartedOn,
      serviceLastEditedOn,
      serviceStatus: "Active"
    };

    console.log(data);
    if (!medium || !language || !numberOfSessions || !durationPerSession || !totalDuration || !descriptionByCoach || !currency || !enterPrice) {
      enqueueSnackbar('Please fill in all required fields', { variant: 'warning' });
      return;
    }

    const numberPattern = /^[0-9]*$/;
    if (!numberPattern.test(numberOfSessions)) {
      enqueueSnackbar('Number of session accepts only numbers', { variant: 'error' });
      return;
    }
    // if (!numberPattern.test(durationPerSession) ) {
    //   enqueueSnackbar('Duration per session should be number only!', { variant: 'error' });
    //   return;
    // }
    if (!numberPattern.test(totalDuration)) {
      enqueueSnackbar('total duration should be number only!', { variant: 'error' });
      return;
    }
    if (!numberPattern.test(enterPrice)) {
      enqueueSnackbar('price should be number only!', { variant: 'error' });
      return;
    }
    if (!numberPattern.test(suggestedPrice)) {
      enqueueSnackbar('suggested Price should be number only!', { variant: 'error' });
      return;
    }
    if (!numberPattern.test(earnedPrice)) {
      enqueueSnackbar('earned Price should be number only!', { variant: 'error' });
      return;
    }
    // Save data in local storage
    data = {
      coach: user._id,
      serviceName,
      medium,
      language,
      numberOfSessions,
      durationPerSession,
      totalDuration,
      descriptionByCoach,
      keyFeatures,
      currency,
      suggestedPrice,
      enterPrice,
      earnedPrice,
      serviceStartedOn,
      serviceLastEditedOn,
    };

    localStorage.setItem("serviceData", JSON.stringify(data));

    navigate("/coach/preview-service");
  };


  return (
    <>
      <Layout>
        <UserLayout userRole={'coach'}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between' ,mt: 8, borderRadius: '10px' }}>
                        <Typography className="heading1bold">Service</Typography>
                        <Grid item xs={12} md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
                            <TextField
                                sx={{ marginLeft: '1rem' }}
                                className='profile-skills-box'
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                              
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Grid>
                    </Box>
          <Paper sx={{ my: 5 }}>
            <Box px={5} py={5}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Add Services
              </Typography>
              <Divider
                sx={{
                  backgroundColor: "#d2d2d2",
                  height: "1px",
                  borderRadius: "2px",
                  marginTop: "1rem",
                }}
              />
            </Box>
            <Box px={5} pb={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={serviceName == "Training" ? 6 : 12}>
                  <InputStylefield name="Select Service*" topSpace={true}>
                    <select
                      className="profile-skills-box"
                      type="text"
                      placeholder="Select"
                      list="Type"
                      value={serviceName}
                      onChange={(e) => setServiceName(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="FULL-TIME">Full Time</option>
                      <option value="PART-TIME">Part Time</option>
                      <option value="FREELANCE">Freelance</option>
                      <option value="Training">Training</option>
                    </select>
                  </InputStylefield>
                </Grid>
                {
                  serviceName == "Training"
                    ?
                    <Grid item xs={12} md={6}>
                      <InputStylefield
                        name="Training*"
                        topSpace={true}
                      >
                        <input type="text" placeholder="Enter Your Training Name" value={trainingName} onChange={(e) => setTrainingName(e.target.value)} />
                      </InputStylefield>
                    </Grid>
                    :
                    ""
                }
                <Grid item md={6} xs={12}>
                  <InputStylefield name="Medium*" topSpace={true} value={medium} onChange={(e) => setMedium(e.target.value)}>
                    <select
                      value={medium}
                      onChange={(e) => setMedium(e.target.value)}
                      className="profile-skills-box"
                    >
                      <option value="" disabled selected>Select Medium</option>
                      <option value="Video">Video</option>
                    </select>
                  </InputStylefield>
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputStylefield name="Language*" topSpace={true} >
                    <select
                      value={language}
                      onChange={(e) => setLanguage(e.target.value)}
                      className="profile-skills-box"
                    >
                      <option value="" disabled selected>Select Language</option>
                      <option value="Hindi">Hindi</option>
                      <option value="English">English</option>
                    </select>
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputStylefield name="No. of Session*" topSpace={true}>
                    <input
                      value={numberOfSessions}
                      onChange={(e) => setNumberOfSessions(e.target.value)}
                      type="text"
                      placeholder="Enter number of sessions"
                    />

                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputStylefield name="Duration Per Session*" topSpace={true} >
                    <select
                      value={durationPerSession}
                      onChange={(e) => setDurationPerSession(e.target.value)}
                      className="profile-skills-box"
                      type="text"
                      placeholder="Select"
                      list="Type"
                    >
                      <option value="">Select</option>
                      <option value="FULL-TIME">Full Time</option>
                      <option value="PART-TIME">Part Time</option>
                      <option value="FREELANCE">Freelance</option>
                    </select>
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputStylefield
                    name="Total Service Duration*"
                    topSpace={true}

                  >
                    <input placeholder="Enter total Duration" value={totalDuration}
                      onChange={(e) => setTotalDuration(e.target.value)} />
                  </InputStylefield>
                </Grid>
                {
                  serviceName == "Training"
                    ?
                    ""
                    :
                    <Grid item xs={12} md={12}>
                      <label className="text2Bold">Description from Admin*</label>
                      <JoditEditor ref={editor} onChange={(newContent) => setDescription(newContent)}
                        value={description} />
                    </Grid>
                }
                <Grid item xs={12} md={12}>
                  <label className="text2Bold">
                    Additional Description By Coach*
                  </label>
                  <JoditEditor
                    ref={editor}
                    value={descriptionByCoach}
                    onChange={(e) => setDescriptionByCoach(e)} />
                </Grid>

                <Grid item xs={12} md={12}>
                  <InputStylefield
                    name="Key Feature of the service"
                    topSpace={true}

                  >
                    <input type="text" placeholder="Additional Details" value={keyFeatures}
                      onChange={(e) => setKeyFeatures(e.target.value)} />
                  </InputStylefield>
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputStylefield name="Currency*" topSpace={true}>
                    <select
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                      className="profile-skills-box"
                      type="text"
                      placeholder="Select"
                      list="Type"
                    >
                      <option value="">Select</option>
                      <option value="FULL-TIME">USD</option>
                      <option value="PART-TIME">INR</option>
                      <option value="FREELANCE">POUND</option>
                    </select>
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputStylefield name="Suggested Price" topSpace={true}>
                    <input type="text" placeholder="Backend" value={suggestedPrice} onChange={(e) => setSuggestedPrice(e.target.value)} />
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputStylefield name="Enter Price*" topSpace={true}>
                    <input type="text" placeholder="Enter Enter Price" value={enterPrice} onChange={(e) => setEnterPrice(e.target.value)} />
                  </InputStylefield>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputStylefield name="Earned Price" topSpace={true}>
                    <input type="text" placeholder="Backend" value={earnedPrice} onChange={(e) => { setEarnedPrice(e.target.value) }} />
                  </InputStylefield>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Button
                    sx={{

                      backgroundColor: "#2544EE",
                      borderRadius: "2rem",
                      color: "#fff",
                      border: "1px solid #2544EE",
                      "&:hover": {
                        color: "#2544EE",
                        backgroundColor: "#F7FAFF",
                      },
                      textTransform: "none",
                      px: 5,
                      width: "100%", // Set the width to 100% to occupy the available space
                      "@media (min-width: 600px)": {
                        width: "auto", // Reset width to auto on larger screens
                      },
                    }}
                    variant="contained"
                    onClick={handlePreview}
                  >
                    Preview
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </UserLayout>
      </Layout>
    </>
  );
}
